<div class="container" (click)="onToggleDropdown()">
    <div class="background"  [ngClass]="{'hide': hideDropDown}"></div>
    <div class="btn">
        <img class="user-icon" src="assets/logos/user.svg">
        <span>
            {{name}}
        </span>
        <img class="arrow-icon" src="assets/logos/arrow-d.svg">

    </div>

    <div class="options-container" (click)="onClickOptions($event)" [ngClass]="{'hide': hideDropDown}">
        <div class="label" (click)="changePassword()">
            <span>
                Alterar senha de acesso
            </span>
        </div>
        <!-- <div class="label" (click)="hideName()">
            
            <span>
                {{ hidePatientName ? 'Mostrar Nome dos Pacientes' : 'Ofuscar Nome dos Pacientes' }}
            </span>
        </div> -->

        <!-- <div class="label" (click)="hideName()">
            
            <span>
                {{ hidePatientName ? 'Sair do modo demonstração' : 'Entrar no modo demonstração' }}
            </span>
        </div> -->
        
        <!-- <div class="languages">
            <div class="label">
                <span>
                    Portugês
                </span>
            </div>
            <div class="label">
                <span>
                    Inglês
                </span>
            </div>
            <div class="label">
                <span>
                    Espanhol
                </span>
            </div>
        </div> -->
        <div class="label" (click)="logout()">
            <span>
                Finalizar Sessão
            </span>
        </div>
    </div>
</div>
